export default __webpack_public_path__ + "static/media/ABChanelCorpo-Regular.d6301acc.woff2";